module.exports = __webpack_public_path__ + "static/media/14UNEP1.94e4a762.jpg";